const restoreEquipments = {
  toastr: 'Restored equipment',
  toastr1: 'Equipment successfully restored'
};

export default restoreEquipments;
